import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormInputTextGroupComponent } from './form-input-text-group.component';
import { SharedModule } from '../../../modules/shared/shared.module';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { FormInputErrorModule } from '../form-input-error/form-input-error.module';
import { InputNumberModule } from 'primeng/inputnumber';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    FormInputTextGroupComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    InputGroupModule,
    InputGroupAddonModule,
    FormInputErrorModule,
    InputNumberModule,
    FormsModule,
  ],
  exports: [
    FormInputTextGroupComponent
  ]
})
export class FormInputTextGroupModule { }
